import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Header from './Header.jsx';
import Sidebar from './Sidebar.jsx';

const DashboardLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user } = useSelector((state) => state.auth);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <Header 
        user={user}
        onToggleSidebar={toggleSidebar}
        onToggleMobileMenu={toggleMobileMenu}
        sidebarCollapsed={sidebarCollapsed}
      />

      <div className="flex min-h-0">
        {/* Sidebar */}
        <Sidebar 
          collapsed={sidebarCollapsed}
          mobileOpen={mobileMenuOpen}
          onCloseMobile={closeMobileMenu}
          userRole={user?.role?.role_name}
        />

        {/* Main Content */}
        <main 
          className={`flex-1 transition-all duration-300 pt-16 ${
            sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-64'
          } min-w-0 overflow-x-hidden`}
        >
          <div className="p-4 sm:p-6 max-w-full">
            {children}
          </div>
          
          {/* Footer */}
          <footer className="bg-white border-t border-gray-200 px-4 sm:px-6 py-4 mt-6 sm:mt-8">
            <div className="text-center text-xs sm:text-sm text-gray-600">
              © 2025 ACTrack - Sistema de Seguimiento de Envíos. Todos los derechos reservados.
            </div>
          </footer>
        </main>
      </div>

      {/* Mobile menu overlay */}
      {mobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
          onClick={closeMobileMenu}
        />
      )}
    </div>
  );
};

export default DashboardLayout;